const app = angular.module('app', []);

app.controller('main', function ($scope) {
  console.log('main controller...');
});



/** WEBPACK FOOTER **
 ** ./app/controllers/Main.js
 **/